<template>
    <div>
        <QBtn
            color="primary"
            noCaps
            outline
            icon="add_circle_outline"
            :label="$t('projects.new')"
            class="full-width q-mb-md"
            @click="$emit('create')"
        />

        <q-expansion-item
            icon="search"
            :label="$t('actions.search')"
            defaultOpened
            class="ContextDrawerExpansion q-mb-sm"
            headerClass="ContextDrawerExpansionHeader"
        >
            <div class="ContextDrawerExpansionContent">
                <QInput
                    v-model="searchProxy"
                    dense
                    outlined
                    type="search"
                    :label="$t('actions.search')"
                    class="q-mb-md"
                    @keyup.enter="$emit('apply-search')"
                >
                    <template #append>
                        <q-icon
                            v-if="searchProxy"
                            name="close"
                            size="20px"
                            clickable
                            style="margin-right: 0.5rem;cursor: pointer;"
                            @click="handleClearSearch"
                        />
                        <q-icon
                            name="search"
                            size="20px"
                            clickable
                            style="cursor: pointer;"
                            @click="$emit('apply-search')"
                        />
                    </template>
                </QInput>
            </div>
        </q-expansion-item>

        <q-expansion-item
            icon="sort"
            :label="$t('general.sorting')"
            defaultOpened
            class="ContextDrawerExpansion ContextDrawerExpansion--last"
            headerClass="ContextDrawerExpansionHeader"
        >
            <div class="ContextDrawerExpansionContent">
                <QSelect
                    :modelValue="sortBy"
                    dense
                    outlined
                    emitValue
                    mapOptions
                    :options="sortOptions"
                    :label="$t('general.sortBy')"
                    class="q-mb-md"
                    @update:model-value="handleSortByChange"
                />

                <div class="text-caption q-mb-xs">
                    {{ $t('general.sortDirection') }}
                </div>
                <QBtnToggle
                    :modelValue="sortDirection"
                    noCaps
                    outline
                    color="primary"
                    toggleColor="primary"
                    :options="sortDirectionOptions"
                    class="full-width ContextDrawerToggle"
                    @update:model-value="handleSortDirectionChange"
                />
            </div>
        </q-expansion-item>
    </div>
</template>

<script>
export default {
    name: 'OrganizationProjectsDrawerPanel',
    props: {
        search: {
            type: String,
            default: '',
        },
        sortBy: {
            type: String,
            required: true,
        },
        sortDirection: {
            type: String,
            required: true,
        },
        sortOptions: {
            type: Array,
            required: true,
        },
        sortDirectionOptions: {
            type: Array,
            required: true,
        },
    },
    emits: [
        'create',
        'apply-search',
        'apply-sort',
        'update:search',
        'update:sortBy',
        'update:sortDirection',
    ],
    computed: {
        searchProxy: {
            get() {
                return this.search
            },
            set(value) {
                this.$emit('update:search', value)
            },
        },
    },
    methods: {
        handleClearSearch() {
            this.$emit('update:search', '')
            this.$emit('apply-search')
        },
        handleSortByChange(value) {
            this.$emit('update:sortBy', value)
            this.$emit('apply-sort')
        },
        handleSortDirectionChange(value) {
            this.$emit('update:sortDirection', value)
            this.$emit('apply-sort')
        },
    },
}
</script>

<style scoped lang="scss">
:deep(.ContextDrawerExpansion) {
    border-top: 1px solid $gray-04;
}

:deep(.ContextDrawerExpansion.ContextDrawerExpansion--last) {
    border-bottom: 1px solid $gray-04;
}

:deep(.ContextDrawerExpansionHeader .q-item__label) {
    font-weight: 700;
}

:deep(.ContextDrawerExpansionHeader .q-item__section--avatar .q-icon) {
    color: $primary;
}

.ContextDrawerExpansionContent {
    padding: 8px 16px 16px;
}

:deep(.ContextDrawerToggle .q-btn[aria-pressed="true"]) {
    background: rgba($primary, 0.12) !important;
}

:deep(.ContextDrawerToggle.q-btn-group--outline:before),
:deep(.ContextDrawerToggle .q-btn--outline:before) {
    border-width: 1px !important;
}
</style>
